import { Nullable } from 'cng-common/models/utils'

import { IMdfActivity } from '../model/types'

import { normalizeMdfOutcome } from './mdfOutcome'

export interface IMdfActivityOutcomeForm {
  outcome: string
  outcomeValueType: string | null
  funnelSizeUsd: Nullable<number>
  leads: Nullable<number>
  conversionRate: Nullable<number>
  attendance: Nullable<number>
  estimatedSalesUsd: Nullable<number>
}

export type TMdfActivityOutcomeFieldChange = <K extends keyof IMdfActivityOutcomeForm>(
  field: K,
  value: IMdfActivityOutcomeForm[K]
) => void

export const calculateMdfEstimatedSales = (
  funnelSizeUsd: Nullable<number>,
  conversionRate: Nullable<number>
): Nullable<number> => {
  if (funnelSizeUsd === null || conversionRate === null) {
    return null
  }

  return funnelSizeUsd * conversionRate
}

type TMdfActivityOutcomeSource = Pick<
  IMdfActivity,
  | 'outcome'
  | 'outcomeValueType'
  | 'funnelSizeUsd'
  | 'leads'
  | 'conversionRate'
  | 'attendance'
  | 'estimatedSalesUsd'
>

export const getEmptyMdfActivityOutcomeForm = (): IMdfActivityOutcomeForm => ({
  outcome: '[]',
  outcomeValueType: null,
  funnelSizeUsd: null,
  leads: null,
  conversionRate: null,
  attendance: null,
  estimatedSalesUsd: null,
})

export const mapMdfActivityToOutcomeForm = (
  activity: TMdfActivityOutcomeSource
): IMdfActivityOutcomeForm => ({
  outcome: normalizeMdfOutcome(activity.outcome),
  outcomeValueType: activity.outcomeValueType,
  funnelSizeUsd: activity.funnelSizeUsd,
  leads: activity.leads,
  conversionRate: activity.conversionRate,
  attendance: activity.attendance,
  estimatedSalesUsd: activity.estimatedSalesUsd,
})
